import {
  IconCategory,
  IconIcons,
  IconLayoutDashboard,
  IconComponents,
  IconMovie,
  IconChartBar,
  IconForms,
  IconRoute,
  IconDatabase,
  IconTestPipe,
  IconTable,
  IconFileText,
} from "@tabler/icons-react";

export const categories = [
  { name: "all", formattedName: "All", icon: IconCategory, color: "gray-500" },
  { name: "charting", formattedName: "Charting", icon: IconChartBar, color: "blue-500" },
  { name: "ui", formattedName: "UI", icon: IconLayoutDashboard, color: "indigo-500" },
  { name: "form", formattedName: "Form", icon: IconForms, color: "green-500" },
  { name: "icons", formattedName: "Icons", icon: IconIcons, color: "yellow-500" },
  { name: "table", formattedName: "Table", icon: IconTable, color: "purple-500" },
  { name: "router", formattedName: "Router", icon: IconRoute, color: "red-500" },
  { name: "animation", formattedName: "Animation", icon: IconMovie, color: "pink-500" },
  { name: "components", formattedName: "Components", icon: IconComponents, color: "teal-500" },
  { name: "state", formattedName: "State Management", icon: IconDatabase, color: "orange-500" },
  { name: "testing", formattedName: "Testing", icon: IconTestPipe, color: "cyan-500" },
  { name: "pdf-viewer", formattedName: "PDF Viewer", icon: IconFileText, color: "amber-500" },
];
